import { render, staticRenderFns } from "./TempletePreview.vue?vue&type=template&id=4e6b38a8"
import script from "./TempletePreview.vue?vue&type=script&lang=js"
export * from "./TempletePreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports